import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { useStateValue } from '../context/state.jsx';
import { closeOpenProject, focusProject, sourceFormatLabel } from '../util/openProject.js';

const ProjectList = ({
	currentDataset,
	setIsFlyoutLeftActive
}) => {
	const [{ datasets }, dispatch] = useStateValue();
	const navigate = useNavigate();
	const datasetMap = datasets && typeof datasets === 'object' ? datasets : {};
	const libraryIds = Object.keys(datasetMap);
	const orderedIds = [
		...libraryIds.filter(id => String(id) === String(currentDataset)),
		...libraryIds.filter(id => String(id) !== String(currentDataset))
	];

	const openProject = (event, datasetId) => {
		event.preventDefault();
		event.stopPropagation();
		setIsFlyoutLeftActive(false);
		focusProject({ dispatch, navigate, datasetId });
	};

	const closeProject = (event, datasetId) => {
		event.preventDefault();
		event.stopPropagation();
		closeOpenProject({
			dispatch,
			navigate,
			datasetId,
			focusedDatasetId: currentDataset
		});
	};

	return (
		<div className="projectListGroups">
			<Panel defaultExpanded>
				<Panel.Heading>
					<Panel.Title toggle>Library ({libraryIds.length})</Panel.Title>
				</Panel.Heading>
				<Panel.Collapse>
					<ListGroup className="projectListGroup">
						{orderedIds.length
							? orderedIds.map(datasetId => {
								const dataset = datasetMap[datasetId];
								const isCurrent = String(currentDataset) === String(datasetId);
								return (
									<div
										key={datasetId}
										className={`list-group-item projectListItem projectListItem-actions${isCurrent ? ' active' : ''}`}>
										<div className="projectListItemMain">
											<button
												type="button"
												className="projectListNameBtn"
												onClick={event => openProject(event, datasetId)}>
												{dataset.Name}
												<span className="sourceFormatBadge">{sourceFormatLabel(dataset)}</span>
												{dataset.p6ProjectNotice ? (
													<span className="projectListChip" title={dataset.p6ProjectNotice}>One P6 project</span>
												) : null}
											</button>
										</div>
										<div className="projectListItemTools">
											{isCurrent
												? null
												: (
													<button
														type="button"
														className="projectListChip projectListChip-primary"
														onClick={event => openProject(event, datasetId)}>
														Open
													</button>
												)}
											<Link
												className="projectListChip"
												to={`/setup/projects/${datasetId}`}
												title="Project settings"
												aria-label={`Project settings for ${dataset.Name}`}
												onClick={() => setIsFlyoutLeftActive(false)}>
												<span className="glyphicon glyphicon-cog"></span>
											</Link>
											{isCurrent
												? (
													<button
														type="button"
														className="projectListChip"
														title="Close project"
														aria-label={`Close ${dataset.Name}`}
														onClick={event => closeProject(event, datasetId)}>
														×
													</button>
												)
												: null}
										</div>
									</div>
								);
							})
							: <ListGroupItem className="projectListEmpty">No projects yet. Add one to start.</ListGroupItem>}
					</ListGroup>
				</Panel.Collapse>
			</Panel>
		</div>
	);
};

ProjectList.propTypes = {
	currentDataset: PropTypes.string,
	setIsFlyoutLeftActive: PropTypes.func
};

export default ProjectList;
